// extracted by mini-css-extract-plugin
export default {"approvalLoader":"AcceptanceApprovalViewer_approvalLoader__UtPbI"};